import * as yup from 'yup';

export const schema = yup.object().shape({
	name: yup.string().required('Ad alanı zorunludur'),
	surname: yup.string().required('Soyad alanı zorunludur'),
	email: yup.string().email('Geçerli bir e-posta giriniz').required('E-posta alanı zorunludur'),
	phone: yup
		.string()
		.required('Telefon alanı zorunludur')
		.matches(/^[0-9]{10}$/, 'Geçerli bir telefon numarası giriniz'),
	city: yup.string().required('İl alanı zorunludur'),
	district: yup.string().required('İlçe alanı zorunludur'),
	workStatus: yup.string().optional(),
	levels: yup.array().required('Branş bilgisi zorunludur')
});
